export const Textarea = {
  defaultProps: {
    focusBorderColor: 'brand.secondary',
  },
}
